import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Select, Dropdown, Tag, Checkbox, Tooltip, Divider,
} from 'antd';
import dayjs from 'dayjs';
import { ControlOutlined, FilterOutlined } from '@ant-design/icons';
import ManualProductionEntryActions from '@Actions/production/manualProductionEntryActions';
import { toISTDate } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3DateSelector from '@Uilib/h3DateSelector';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import PRZModal from '../../../Common/UI/PRZModal';
import PRZText from '../../../Common/UI/PRZText';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;

function ManualProductionEntryList({
  user, history, getManualProductionEntryLoading, departments, getManualProductionEntries, manualProductionEntries,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [listScreenView, setListScreenView] = useState(true);
  const [limit, setLimit] = useState(25);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState('');
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState('');
  const [selectedSeller, setSelectedSeller] = useState('');
  const [call, setCall] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [fixedColumns, setFixedColumns] = useState(['MO_NO']);
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [isArchived, setIsArchived] = useState('false');
  const [scheduledStartDate, setScheduledStartDate] = useState('');
  const [scheduledEndDate, setScheduledEndDate] = useState('');
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [reportType, setReportType] = useState('without_raw_materials');
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');
  const [scheduledDateSelectedIntervalDateRangeType, setScheduledDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  // useEffect(() => {
  //   if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id) {
  //     if (user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
  //       setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
  //       setSelectedDepartment(Helpers.getDepartmentId(user)?.toString());
  //     }
  //   }
  //   setSelectedEmails([user?.email]);
  // }, [user]);

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-mpe') ? JSON.parse(localStorage.getItem('prcz-page-columns-mpe')) : {
    MO_NO: {
      label: 'Production Entry#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    FINISHED_GOODS: {
      label: 'Finished Goods',
      visible: true,
    },
    ORDER_STATUS: {
      label: 'Order Status',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    ENTRY_DATE: {
      label: 'Entry Date',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });

  const getColumns = () => {
    const listColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.production_entry_number ? record.production_entry_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name || ''}(${record?.department_name || 'N/A'})`?.trim()}
                  className="mobile-list__card_item-details"
                />
                {record?.created_at && (
                  <PRZText
                    text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                )}
                {record?.production_entry_date && (
                  <PRZText
                    text={`Entry Date - ${toISTDate(record?.production_entry_date).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                )}
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Quantity" />
                  )}
                >
                  <div>
                    {
                      record?.fg_info?.map((rec) => (
                        <div>
                          {`${rec?.quantity} ${rec?.uom_info?.uqc?.toProperCase()}`}
                        </div>
                      ))
                    }
                  </div>
                </Tooltip>
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Raw Materials" />
                  )}
                >
                  <PRZText
                    text={record?.raw_materials_count}
                    style={{ fontSize: '13px' }}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Finished Good" />
                  )}
                >
                  {
                    record?.fg_info?.map((rec) => (
                      <div className="me-table__fg-names">
                        <div>
                          <a>
                            {`#${rec?.internal_sku_code} ${rec?.ref_product_code ? `${rec?.ref_product_code} - ` : ''}${rec?.product_sku_name}`}
                          </a>
                        </div>
                      </div>
                    ))
                  }
                </Tooltip>
              </div>
              <div className="mobile-list__card_footer-right" />
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'ENTRY#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MO_NO?.visible ? 'display-none' : '',
        fixed: 'left',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.production_entry_number} className="common-table-blue-text" />
          </div>
        ),
      },
      {
        title: 'LOCATION',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
        fixed: 'left',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={(record?.department_name ? `${record?.department_name}` : '')} className="table-subscript" />
          </div>
        ),
      },
      {
        title: 'FINISHED GOOD',
        render: (item) => {
          const { fg_info } = item;
          return (
            <div className="min-width-100">
              {
                fg_info?.map((rec) => (
                  <div className="me-table__fg-names">
                    <div onClick={() => {
                      setShowPRZModal(true);
                      setCurrentProduct(rec?.product_sku_id);
                    }}
                    >
                      <a>
                        {`#${rec?.internal_sku_code} ${rec?.ref_product_code ? `${rec?.ref_product_code} - ` : ''}${rec?.product_sku_name}`}
                      </a>
                    </div>
                  </div>
                ))
              }
              <PRZModal
                isOpen={showPRZModal}
                onClose={() => {
                  setShowPRZModal(false);
                }}
                entityType="product"
                documentId={currentProduct}
              />
            </div>
          );
        },
        responsive: ['md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FINISHED_GOODS?.visible ? 'display-none' : '',
      },
      {
        title: 'QUANTITY',
        render: (item) => {
          const { fg_info } = item;
          return (
            <div className="min-width-85">
              {
                fg_info?.map((rec) => (
                  <div>
                    {`${rec?.quantity} ${rec?.uom_info?.uqc?.toProperCase()}`}
                  </div>
                ))
              }
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'RAW MATERIALS',
        render: (record) => (
          <div className="min-width-100">
            {record?.raw_materials_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="me__status min-width-70" style={{ color: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ORDER_STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="min-width-85">
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ENTRY DATE',
        render: (text, record) => (
          <div className="min-width-85">
            {dayjs(record?.production_entry_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ENTRY_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
    ];
    listColumns.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div className="list__actions list__actions__single">
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              history.push(`/production/manual-entry/view/${record.production_entry_id}`);
            }}
          >
            View
          </div>
        </div>
      ),
      responsive: ['md', 'lg', 'xxl'],
      hidden: isPortrait,
    });
    return listColumns.filter((item) => !item.hidden);
  };
  const pushParamsToUrl = (page, limit, status, word, start, end, tenant, vendor, dept, listScreen, isArchived, MOScheduledStartDate, ScheduledEndDate , orderDateSelectedIntervalDateRangeType, scheduledDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (status) url += `&status=${status}`;
    if (word) url += `&keyword=${word}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (tenant) url += `&tenant=${tenant}`;
    if (vendor) url += `&seller_id=${vendor}`;
    if (dept) url += `&department_id=${dept}`;
    if (listScreen) url += `&list_screen=${listScreen}`;
    if (isArchived) url += `&is_archived=${isArchived}`;
    if (MOScheduledStartDate) url += `&scheduledStartDate=${MOScheduledStartDate}`;
    if (ScheduledEndDate) url += `&scheduledEndDate=${ScheduledEndDate}`;
    if (scheduledDateSelectedIntervalDateRangeType) url += `&scheduled_date_type=${scheduledDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'startDate',
        filter_value: Helpers.getValueFromUrl('startDate') || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'scheduledStartDate',
        filter_value: Helpers.getValueFromUrl('scheduledStartDate') || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('scheduled_date_type') || '',
      },
      {
        filter_key: 'scheduledEndDate',
        filter_value: Helpers.getValueFromUrl('scheduledEndDate') || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('scheduled_date_type') || '',
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Helpers.getValueFromUrl('department_id') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'is_archived',
        filter_value: Number(Helpers.getValueFromUrl('is_archived')) || false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : [],
        filter_type: filterTypeEnums.STRING,
      }
    ];
    return appliedFiltersFromURL;
  }
  
  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'scheduledStartDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'scheduledEndDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department_id',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'is_archived',
        filter_value: false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'status',
        filter_value: [],
        filter_type: filterTypeEnums.STRING,
      }
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.MANUAL_ENTRY,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);


        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDateMomentEpoch(tempFilterValues.startDate);
        setEndDateMomentEpoch(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setScheduledStartDate(tempFilterValues.scheduledStartDate);
        setScheduledEndDate(tempFilterValues.scheduledEndDate);
        setScheduledDateSelectedIntervalDateRangeType(tempFilterValues.scheduledDateRangeType);
        setIsArchived(tempFilterValues.is_archived);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          setSelectedDepartment(tempFilterValues.department_id || Helpers.getDepartmentId(user)?.toString());
        } else {
          setSelectedDepartment(tempFilterValues.department_id);
        }
      }

      setSelectedEmails([user?.email]);

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setSelectedStatus(Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : []);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setStartDateMomentEpoch(Helpers.getValueFromUrl('startDate'));
  //     setEndDateMomentEpoch(Helpers.getValueFromUrl('endDate'));
  //     setScheduledStartDate(Helpers.getValueFromUrl('scheduledStartDate'));
  //     setScheduledEndDate(Helpers.getValueFromUrl('scheduledEndDate'));
  //     if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
  //       setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
  //       setSelectedDepartment(Helpers.getValueFromUrl('department_id') || Helpers.getDepartmentId(user)?.toString());
  //     } else {
  //       setSelectedDepartment(Helpers.getValueFromUrl('department_id'));
  //     }
  //     setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
  //     setIsArchived(Helpers.getValueFromUrl('is_archived') || 'false');
  //     setIsUserReady(true);
  //     setListScreenView(true);
  //   }
  // }, []);

  /**
 *
 */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedStatus, searchKeyword, startDateMomentEpoch, endDateMomentEpoch, selectedTenant, selectedSeller, selectedDepartment, listScreenView, isArchived, scheduledStartDate, scheduledEndDate, orderDateSelectedIntervalDateRangeType, scheduledDateSelectedIntervalDateRangeType, selectedFilterView);
      const payload = {
        tenantId: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)?.join(','),
        peId: null,
        status: Helpers.getValueFromUrl('status'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        departmentId: Helpers.getValueFromUrl('department_id'),
        fromDate: Helpers.getValueFromUrl('startDate'),
        toDate: Helpers.getValueFromUrl('endDate'),
        scheduledStartDate: Helpers.getValueFromUrl('scheduledStartDate'),
        scheduledEndDate: Helpers.getValueFromUrl('scheduledEndDate'),
      };
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getManualProductionEntries(payload, () => { });
      setSelectedRowKeys(null);
      setSelectedRows(null);
    }
  }, [selectedStatus, searchKeyword, currentPage, selectedTenant, selectedDepartment, selectedSeller, call, startDateMomentEpoch, endDateMomentEpoch, limit, listScreenView, isArchived, scheduledStartDate, scheduledEndDate, orderDateSelectedIntervalDateRangeType, scheduledDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const statusOptions = [
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'VOID', value: 'VOID', label: 'Void' },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Manual Entry..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Manual Entry"
                      onClick={() => history.push('/production/manual-entry/create')}
                      customClass="add-button"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDateMomentEpoch(tempFilterValues.startDate ? dayjs(tempFilterValues.startDate) : null);
                    setEndDateMomentEpoch(tempFilterValues.endDate ? dayjs(tempFilterValues.endDate) : null);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setScheduledStartDate(tempFilterValues.scheduledStartDate);
                    setScheduledEndDate(tempFilterValues.scheduledEndDate);
                    setScheduledDateSelectedIntervalDateRangeType(tempFilterValues.scheduledDateRangeType);
                    setIsArchived(tempFilterValues.is_archived);
                    setSelectedDepartment(tempFilterValues.department_id);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.MANUAL_ENTRY}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag
                    closable
                    color="#2d7df7"
                    onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }}
                  >
                    Search Results for
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedStatus && selectedStatus?.map((item, index) => (
                  <Tag closable onClose={() => setSelectedStatus(selectedStatus.filter((tId) => tId !== item))} color="#2d7df7">
                    {' '}
                    Status -
                    &nbsp;
                    <span><b>{item?.replaceAll('_', ' ').toUpperCase()}</b></span>
                    {' '}
                  </Tag>
                ))}
                {
                  (startDateMomentEpoch && endDateMomentEpoch) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDateMomentEpoch(null);
                        setEndDateMomentEpoch(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDateMomentEpoch).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDateMomentEpoch).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {
                  (scheduledStartDate !== '2000-01-01' && scheduledEndDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setScheduledStartDate(null);
                        setScheduledEndDate(null);
                        setScheduledDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      Scheduled From:
                      &nbsp;
                      <span><b>{dayjs(scheduledStartDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      Scheduled To:
                      &nbsp;
                      <span><b>{dayjs(scheduledEndDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : (scheduledStartDate === '2000-01-01' && scheduledEndDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setScheduledStartDate(null);
                        setScheduledEndDate(null);
                      }}
                      color="#2d7df7"
                    >
                      &nbsp;
                      Over Due Till -
                      &nbsp;
                      <span><b>{dayjs(scheduledEndDate).add(1, 'day').format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
              </div>
            </div>  
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(manualProductionEntries && manualProductionEntries.count) ? manualProductionEntries.count : '0'} Manual Entries`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <H3DateSelector
                          startDate={startDateMomentEpoch}
                          endDate={endDateMomentEpoch}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDateMomentEpoch(dayjs((date[0])?.valueOf()).format('YYYY-MM-DD'));
                            setEndDateMomentEpoch(dayjs((date[1])?.valueOf()).format('YYYY-MM-DD'));
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        <Dropdown
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container me__header__section-status filter__container-section">
                                <div className="filter__title"> Business Unit </div>
                                <TenantSelector
                                  selectedTenant={selectedTenant}
                                  showSearch
                                  isMultiple
                                  onChange={(value) => {
                                    if (value === 'All') {
                                      setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ));
                                      setCurrentPage(1);
                                    } else {
                                      setSelectedTenant(value);
                                      setCurrentPage(1);
                                    }
                                  }}
                                  placeholder="Select Business Unit"
                                  hideTitle
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)}
                                />
                              </div>
                              <div className="filter__container me__header__section-status filter__container-section">
                                <div className="filter__title"> Department </div>
                                <SelectDepartment
                                  title="Select Department"
                                  hideTitle
                                  selectedDepartment={Number(selectedDepartment) || ''}
                                  onChange={(value) => {
                                    setSelectedDepartment(value?.department_id?.toString() || '');
                                    setCurrentPage(1);
                                  }}
                                  disabled={departmentLevelVisibility}
                                />
                              </div>
                              <div className="filter__container me__header__section-status filter__container-section">
                                <div className="filter__title"> Order Status </div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  style={{ width: '100%' }}
                                  placeholder="Search by Status.."
                                  mode="multiple"
                                  maxTagCount="responsive"
                                  showSearch={false}
                                  options={statusOptions}
                                />
                              </div>

                            </div>
                          )}
                        >
                          <div className="action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-mpe', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-mpe', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                loading={getManualProductionEntryLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && manualProductionEntries && !!manualProductionEntries?.production_entries?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && manualProductionEntries && !!manualProductionEntries?.production_entries?.length}
                columns={getColumns()}
                bordered
                dataSource={manualProductionEntries && manualProductionEntries?.production_entries ? manualProductionEntries?.production_entries?.map((item) => ({
                  ...item,
                  key: item?.production_entry_id,
                })) : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: manualProductionEntries ? manualProductionEntries.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers, ManualProductionEntryReducers,
}) => ({
  user: UserReducers.user,
  getManualProductionEntryLoading: ManualProductionEntryReducers.getManualProductionEntryLoading,
  departments: DepartmentReducers.departments,
  manualProductionEntries: ManualProductionEntryReducers.manualProductionEntries,
});

const mapDispatchToProps = (dispatch) => ({
  getManualProductionEntries: (payload, callback) => dispatch(
    ManualProductionEntryActions.getManualProductionEntries(payload, callback),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManualProductionEntryList));
